import React from 'react'

import classNames from 'clsx'

import { Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'

import createLogger from '~/src/Lib/Logging'
import { EMPTY_OBJECT, shallowEquals } from '~/src/Lib/Utils'

import { formatPart, parseText } from './utils'

const displayName = 'SmartText'
const logger = createLogger(displayName)

const useStyles = makeStyles(theme => ({
  root: {
    '& $email, & $url': {
      color: theme.palette.appPrimary.main,
      textDecoration: 'underline',
    }
  },
  email: {},
  mention: {
    color: theme.palette.appPrimary.light,
    fontFamily: theme.typography.boldFontFamily,
  },
  url: {},
}), { name: displayName })

export const Component = ({ TypographyProps = EMPTY_OBJECT, text }) => {
  const classes = useStyles()
  if (!text) return null

  const parts = parseText(text)

  return (
    <Typography
      {...TypographyProps}
      className={classNames(classes.root, TypographyProps.className)}
    >
      {parts.map(part => (
        typeof part === 'string' || !part
          ? part || null
          : formatPart(part, classes)
      ))}
    </Typography>
  )
}

const Memoized = React.memo(Component, (prevProps, nextProps) => shallowEquals(prevProps, nextProps, 2))

export default Memoized
